<template lang="html">
  <div class="detail">
    <!-- <h3 class="detail-title">星圈</h3> -->
    <div class="content">
      <DynamicItem v-if="loading" @updateItem="updateItem" :upCount="upCount" :isUp="isUp" :downCount="downCount" :isDown="isDown" :isActual="isActual" :tags="tags" :commentCount="commentCount" :id="id" :user="user" :images="images" :crateTime="createTime" :content="content" />
        <button @click="goCreate" v-if="messages.length === 0" class="emptyWrite">写留言</button>
        <template v-else>
          <div class="message">
            <h3>{{messages.length}}条留言</h3>
            <DynamicMessage v-for="item of messages" @deleteMessage="deleteMessage" @thumbsUp="childthumbsUp(item)" :key="item.id" v-bind="item" />
          </div>
        </template>
    </div>
    <div class="footer" v-if="messages.length !== 0">
      <button @click="goCreate" class="write" type="text"><span class="icon iconfont">&#xe68c;</span>写留言</button>
    </div>
    <Suspension v-if="platform !== 'notInDingTalk'" @share="getShareContent"/>
    <Suspension bottom="36px" desc="更多吐槽" img="false" @share="goParent"/>
  </div>
</template>
<script>
import { isAndroid } from '../../../utils/utils'
import DynamicItem from './Item'
import DynamicMessage from './Message'
import { get } from '../../../utils/request'
import { get as getUser } from '../../../utils/token'
import DDMixis from '../../../minixs/ddMixis'
export default {
  mixins: [DDMixis],
  components: {
    DynamicItem,
    DynamicMessage
  },
  created () {
    const { nickName, id, userId } = this.$route.params
    this.id = id
    this.user.nickName = nickName
    this.user.id = userId
    this.getDissDetails(id)
    this.getDynamicMessage(id)
  },
  data () {
    return {
      loading: false,
      isAndroid: isAndroid(),
      safeHeight: 0,
      id: 1,
      isUp: false,
      isActual: true,
      isDown: false,
      user: {
        id: '',
        nickName: '',
        avatar: ''
      },
      createTime: '',
      upCount: 0,
      downCount: 0,
      content: '',
      commentCount: 111,
      images: [],
      messages: [],
      tags: []
    }
  },
  methods: {
    goParent () {
      this.$router.push({
        path: '/exerland/makeComplaints'
      })
    },
    updateItem (reload) {
      Object.assign(this, reload)
    },
    childthumbsUp (item) {
      item.isUp = !item.isUp
      let count = item.upCount
      if (item.isUp) {
        ++count
      } else {
        --count
      }
      item.upCount = count
    },
    deleteMessage () {
      const { id } = this.$route.params
      this.getDynamicMessage(id)
    },
    getDissDetails (id) {
      this.loading = false
      const user = getUser('user')
      const promise = get({
        url: `/diss/detail/${id}/${user.id}`
      })
      promise.then(res => {
        const {
          data: { code, detail }
        } = res
        if (Object.is(code, 200)) {
          Object.assign(this, detail)
        }
        this.loading = true
      })
    },
    getDynamicMessage (id) {
      const user = getUser('user')
      const promise = get({
        url: `/diss/commentTree/${id}/${user.id}`
      })
      promise.then(res => {
        const {
          data: { code, detail }
        } = res
        if (Object.is(code, 200)) {
          this.messages = detail
        }
      })
    },
    goCreate () {
      const { id } = this
      this.$router.push(`/exerland/makeComplaintsCreate?dissId=${id}`)
    }
  }
}
</script>
<style lang="scss" scoped>
@import "../../../assets/font/iconfont.css";
.detail {
  background: #fff;
  position: fixed;
  left: 0;
  top: 0;
  height: 100%;
  .content {
     overflow-y: scroll;
     height: calc(100% - 40px);
     .detail-title {
      font-size: 17px;
      font-family: SFProText-Semibold, SFProText;
      font-weight: 600;
      color: rgba(0, 0, 0, 1);
      line-height: 22px;
      text-align: center;
      padding: 13px 4.27vw;
      overflow: scroll;
    }
    .emptyWrite {
      display: inherit;
      width: 132px;
      height: 44px;
      background: rgba(245, 245, 245, 1);
      border-radius: 4px;
      font-size: 17px;
      border: none;
      margin: 85px auto 0;
    }
    .message {
      h3 {
        font-size: 18px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: bold;
        color: rgba(51, 51, 51, 1);
        line-height: 20px;
        padding: 13px 4.27vw;
      }
    }
  }
  .footer {
    position: fixed;
    bottom: 0;
    left: 0;
    width: 100vw;
    height: 40px;
    background: #fff;
    z-index: 9;
    box-sizing: border-box;
    // line-height: 40px;
    border-top: 1px solid #f5f5f5;
    .write {
      width: 100%;
      color: rgba(51, 51, 51, 1);
      font-size: 17px;
      .icon {
        margin-right: 4px;
      }
    }
  }
}
/deep/ .content-item {
  border: none;
  .content-bottom {
    justify-content: flex-end;
  }
}
button {
      border: none;
      outline: none;
      background: #fff;
      height: 40px;
    }
</style>
